<div class="layout-topbar">
  <div class="layout-topbar-logo-container">
    <button
      class="layout-menu-button layout-topbar-action"
      (click)="layoutService.onMenuToggle()"
    >
      <i class="pi pi-bars"></i>
    </button>
    <a class="layout-topbar-logo" routerLink="/">
      <img src="/images/logo.svg" alt="logo" class="w-40" />
    </a>
  </div>

  <div class="layout-topbar-actions">
    <div class="layout-config-menu">
      <app-configurator />
    </div>

    <button
      class="layout-topbar-menu-button layout-topbar-action"
      pStyleClass="@next"
      enterFromClass="hidden"
      enterActiveClass="animate-scalein"
      leaveToClass="hidden"
      leaveActiveClass="animate-fadeout"
      [hideOnOutsideClick]="true"
    >
      <i class="pi pi-ellipsis-v"></i>
    </button>

    <div class="layout-topbar-menu hidden lg:block">
      <div class="layout-topbar-menu-content">
        @if(loggedUserFullname()){
        <div class="">
          <p-button (click)="menu.toggle($event)" text class="mb-10">
            {{ loggedUserFullname() }}
            <i class="ph ph-caret-down"></i>
             
          </p-button>
          <p-menu
            #menu
            [model]="items"
            [popup]="true"
            appendTo="#userMenuOptions"
            class="user-menu"
          />
        </div>
        <ng-template #userMenuOptions></ng-template>
        }@else{
        <a pButton type="button" routerLink="/auth/sign-in" text> Entrar </a>
        }
      </div>
    </div>
  </div>
</div>
